import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { JwtHelper } from '../../jwt-decoder/jwt-helper';

import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  jwtHelper: JwtHelper =  new JwtHelper();

  constructor(private route: Router, private http: HttpClient) { }

  setToken(token: any) {
    localStorage.setItem('token', token)
  }

  getToken() {
    return localStorage.getItem('token')
  }

  isAuthenticated() {
    return this.getToken() !== null;
  }

  /**
   * Best-effort signout: clears the localStorage token and asks the
   * backend to invalidate the httpOnly JWT cookie. The redirect happens
   * regardless of the server response (the client-side token has
   * already been wiped).
   */
  logout() {
    localStorage.removeItem('token');
    const logoutUrl = environment.baseUrl.replace(/\/\d+\/?$/, '/') + 'logout';
    this.http.post(logoutUrl, {}, { withCredentials: true }).subscribe({
      next: () => this.route.navigate(['/login']),
      error: () => this.route.navigate(['/login']),
    });
  }

  decode() {
    const token = localStorage.getItem('token');
    if (token !== null) {
      return this.jwtHelper.decodeToken(token);
    }
  }

  decodeToken(token: any) {
    return this.jwtHelper.decodeToken(token);
  }
}
